<!-- eslint-disable -->
<template>
  <div>
    <a-steps :current="current" size="small" v-if="from !== 'meeting'">
      <a-step title="选择目录" />
      <a-step title="上传文件" />
      <a-step title="权限设置" />
    </a-steps>
    <div class="choose_file" v-show="+current === 0 && !showMeetingOffline">
      <vue-scroll>
        <ul class="file_box">
          <a-radio-group v-model="fileTypeId">
            <div
              v-for="(item, index) in fileList"
              :key="index"
              class="file_item"
              :style="{ color: +fileTypeId === +item.id ? '#1890ff' : '#999' }"
              @click="chooseFile(item)"
            >
              <a-radio :value="item.id"> </a-radio>
              <a-icon type="file" :style="{ color: +fileTypeId === +item.id ? '#1890ff' : '#999' }" />
              {{ item.name }}
              <div
                v-if="
                  showSubType[item.id] &&
                    item.subFiletypes &&
                    item.subFiletypes.length > 0 &&
                    (item.id === SETTLEMENT_INVESRMENT_FILETYPE_ID || item.id === SETTLEMENT_EXIT_FILETYPE_ID)
                "
              >
                <div v-for="subFileType in item.subFiletypes" :key="subFileType.id" class="sub-file">
                  <div @click.stop="chooseSubFiles(subFileType)" :style="{ color: subFiles[subFileType.id] ? '#1890ff' : '#999' }">
                    <a-checkbox class="checkbox" v-model="subFiles[subFileType.id]"></a-checkbox>
                    <a-icon type="file" :style="{ color: subFiles[subFileType.id] ? '#1890ff' : '#999' }" />{{ subFileType.name }}
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="showSubType[item.id] && item.subFiletypes && item.subFiletypes.length > 0">
                  <a-radio-group v-model="chooseFileId">
                    <div v-for="subFileType in item.subFiletypes" :key="subFileType.id" class="sub-file">
                      <div @click.stop="chooseSubFiles(subFileType)" :style="{ color: subFileType.id === chooseFileId ? '#1890ff' : '#999' }">
                        <a-radio class="checkbox" :value="subFileType.id"></a-radio>
                        <a-icon type="file" :style="{ color: subFileType.id === chooseFileId ? '#1890ff' : '#999' }" />{{ subFileType.name }}
                      </div>
                    </div>
                  </a-radio-group>
                </div>
              </div>
            </div>
          </a-radio-group>
        </ul>
      </vue-scroll>
    </div>
    <div class="warn warn-box" v-show="+current === 0 && !showMeetingOffline">
      <div>每次支持上传多个文档，但只能上传到相同的文档目录，配置相同的文档权限。</div>
      <div>如有多种需求，请分批次上传。</div>
    </div>
    <div class="meeting_offline" v-show="+current === 0 && showMeetingOffline">
      <div class="content-item">
        <div class="item-title ant-form-item-required">会议日期：</div>
        <a-date-picker v-model="meetingOffline.meetingDate" :allowClear="false" style="width: 300px" />
      </div>
      <div class="content-item">
        <div class="item-title ant-form-item-required">会议名称：</div>
        <a-input v-model="meetingOffline.name" style="width: 300px" />
      </div>
      <div class="content-item">
        <div class="item-title">参与人：</div>
        <div class="dealmembers">
          <select-member :width="300" :userlist="meetingOffline.users" @delChosenUser="delOfflineMeetingUsers" @chose="chooseOfflineMeetingUsers">
          </select-member>
        </div>
      </div>
      <div class="content-item">
        <div class="item-title">讨论内容：</div>
        <a-textarea style="width: 300px" v-model="meetingOffline.content" />
      </div>
    </div>
    <div class="steps-content" v-show="+current === 1">
      <div style="padding-bottom: 30px" v-if="from !== 'meeting'">
        <span class="label">所属轮次</span>
        <stageMulSelect
          v-if="(fileTypeId === SETTLEMENT_INVESRMENT_FILETYPE_ID || fileTypeId === SETTLEMENT_EXIT_FILETYPE_ID) && subFileTypeIds.length > 0"
          style="width: 300px"
          :type="1"
          :companyId="this.$route.query.id"
          :value="roundValue"
          :selectDisabled="selectDisabled"
          @input="getSelected"
          :subFileTypeIds="subFileTypeIds"
        ></stageMulSelect>
        <stageSelect
          style="width: 150px"
          :type="1"
          :companyId="this.$route.query.id"
          :value="roundValue"
          :selectDisabled="selectDisabled"
          @input="getSelected"
          v-else
        ></stageSelect>
      </div>
      <div style="padding-bottom: 20px; margin: 0 -10px">
        <div style="margin-bottom: 10px">
          文档类型：
          <a-radio-group v-model="isFeishu">
            <a-radio :value="false">
              本地文档
            </a-radio>
            <a-radio :value="true">
              飞书文档
            </a-radio>
          </a-radio-group>
        </div>
        <a-upload-dragger
          v-show="!isFeishu"
          name="file"
          :multiple="+fileTypeId === MEETING_AUDIO_FILETYPE_ID ? false : true"
          :defaultFileList="defaultFileList"
          :headers="headers"
          :data="getUploadObj"
          :beforeUpload="beforeUpload"
          :action="+fileTypeId === MEETING_AUDIO_FILETYPE_ID ? offlineMeetingAction : uploadAction"
          @change="handleChange"
          :remove="removeFile"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            直接拖拽文件到此处即可上传，或点击
            <a>点击上传</a>
          </p>
          <p class="ant-upload-hint">（单个文件最大500MB）</p>
        </a-upload-dragger>
        <div class="" v-show="isFeishu">
          <a-input placeholder="请输入飞书文档链接" v-model="feishuLink" />
          <div style="margin: 10px 0;">
            <a-button @click="addFeishuLink">添加</a-button>
            <span class="tips">操作完成后，飞书文档将转移到项目/会议文件夹</span>
          </div>
        </div>
      </div>
      <div class="lock-icons">
        <div v-for="file in uploadFiles" :key="file.uid" class="icon">
          <a-icon v-if="file.isSecret" type="lock" />
          <div v-else></div>
        </div>
      </div>
      <div v-for="item in tempFiles" :key="item.name">{{ item.name }}</div>
      <template v-if="from !== 'meeting' && isFeishu">
        <div v-for="(item, index) in feishuList" :key="item.name" class="feishu-list-item">
          <span>{{ item.name }}</span>
          <a-button type="link" shape="circle" size="small" icon="delete" @click="deleteFeishu(index)" />
        </div>
      </template>
    </div>
    <div class="steps-content" v-show="+current === 2">
      <div>
        <a-select :value="+isDefault === 1 ? '自定义' : '默认'" style="width: 120px" @change="permissChange">
          <a-select-option :value="0">默认</a-select-option>
          <a-select-option :value="1">自定义</a-select-option>
        </a-select>
      </div>
      <div class="steps-content permiss_settings">
        <!-- 默认权限 -->
        <ul v-if="+isDefault === 0">
          <li v-for="(item, index) in permission" :key="index">
            <span style="margin-right: 10px">{{ item.companyFileTypeDesc }}:</span>
            <select-member
              :canEdit="false"
              :canDeleteAll="false"
              :abridged="7"
              :width="500"
              :parentIndex="index"
              :userlist="item.users"
              :canExpand="true"
            ></select-member>
          </li>
        </ul>
        <!-- 自定义权限 -->
        <ul v-if="+isDefault === 1">
          <li v-for="(item, index) in customPermission" :key="index">
            <span style="margin-right: 10px">{{ item.companyFileTypeDesc }}:</span>
            <select-member
              :canEdit="+isDefault === 1 && index !== 2 ? true : false"
              :canDeleteAll="+isDefault === 1 && item.users.length > 0 && index !== 2 ? true : false"
              :abridged="+isDefault === 1 ? 6 : 7"
              :width="500"
              :parentIndex="index"
              :userlist="item.users"
              :canExpand="true"
              @chose="choseUserIds"
              @delChosenUser="delUserIds"
              @delAllUsers="delAllUsers"
            ></select-member>
          </li>
        </ul>
      </div>
    </div>
    <div class="steps-action clearfix">
      <template v-if="from !== 'meeting'">
        <a-button class="pull-right btn" v-if="current === 1" type="primary" @click="next()" :disabled="uploadFiles.length === 0 && feishuList.length === 0"
          >去配置权限</a-button
        >
        <a-button class="pull-right btn" v-if="current === 1" type="primary" @click="next(true)" :disabled="uploadFiles.length === 0 && feishuList.length === 0"
          >默认权限&完成上传</a-button
        >
        <a-button class="pull-right btn" v-if="+current === 2" @click="setPermissionUsers(true)">保存</a-button>
        <a-button class="pull-right btn" v-if="current === 1" type="primary" @click="last" :disabled="uploadFiles.length + feishuList.length > 0"
          >上一步</a-button
        >
        <a-button class="pull-right btn" v-if="current === 0" type="primary" @click="next()">下一步</a-button>
        <a-button class="pull-right btn" v-if="+current === 0 && !showMeetingOffline" style="margin-right: 8px" @click="prev">取消</a-button>
        <a-button class="pull-right btn" v-if="+current === 0 && showMeetingOffline" style="margin-right: 8px" @click="last">上一步</a-button>
      </template>
      <template v-else>
        <a-button class="pull-right btn" type="primary" @click="selectOk()">{{ tempFiles.length === 0 ? '关闭' : '选定' }}</a-button>
        <a-button class="pull-right btn" v-if="current === 1 && categoryType === '其他'" type="primary" @click="last">上一步</a-button>
        <a-button class="pull-right btn" v-if="current === 0" type="primary" @click="next()">下一步</a-button>
      </template>
    </div>
    <a-modal :width="600" :visible="secretFileList.length > 0" title="文档密码" :closable="false" :maskClosable="false" :footer="null">
      <div class="secret-content">
        <div class="warn">
          <div>系统检测到以下文档为加密文档，无法在天池中正常预览，请填写该文档密码，以便其他用户阅读。</div>
          <div>如有特殊的权限/保密需求，则可在上传文档后进行个性化权限配置</div>
        </div>
        <a-row v-for="file in secretFileList" :key="file.name" class="password-line">
          <a-col :span="1">
            <a-icon type="lock" class="lock-icon" />
          </a-col>
          <a-col :span="17" class="title">{{ file.name }}</a-col>
          <a-col :span="6">
            <a-input v-model="secretMap[file.uid]" size="small" placeholder="请输入文档密码"></a-input>
          </a-col>
        </a-row>
        <div class="btns">
          <a-button class="btn" @click="cancelPassword"> 取消 </a-button>
          <a-button class="btn" @click="confirmPassword" type="primary" :disabled="!secretReady">继续上传</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import selectMember from '@/components/project/selectMember';
import { getPermissionUsers, setPermissionUsers, deleteFile } from '@/api/project';
import { uploadSelectList, documentTypeList } from '@/api/document';
import { queryFeishuDocInfo } from '@/api/meeting';
import xlsx from 'xlsx';
import Event from '@/utils/event';
import { MEETING_AUDIO_FILETYPE_ID, SETTLEMENT_INVESRMENT_FILETYPE_ID, SETTLEMENT_EXIT_FILETYPE_ID } from '@/common/constant';
import debounce from 'lodash/debounce';
import stageSelect from '@/components/base/stageSelect';
import stageMulSelect from '@/components/base/stageMulSelect.vue';
import { meetingUploadlist } from '@/utils/project';
import { uploadFile, uploadOfflineNeetingFile } from '@/api/common';
import moment from 'moment';

export default {
  components: { selectMember, stageSelect, stageMulSelect },
  props: ['typeId', 'companyId', 'annexId', 'file', 'roundValue', 'from', 'categoryType', 'round'],
  data() {
    this.setPermissionUsers = debounce(this.setPermissionUsers, 1000);
    return {
      MEETING_AUDIO_FILETYPE_ID: MEETING_AUDIO_FILETYPE_ID,
      current: 0,
      fileTypeId: '',
      isFeishu: false,
      feishuList: [],
      uploadAction: process.env.VUE_APP_BASE_API + '/upload/companyFile',
      offlineMeetingAction: process.env.VUE_APP_BASE_API + '/upload/uploadOfflineMeetingProjectAudio',
      uploadDuration: 0,
      companyFileId: [],
      isDefault: 0, //默认是0，自定义是1
      tempEdit: '',
      fileList: [],
      permission: [], //默认权限
      customPermission: [], //自定义权限
      uploadFiles: [], //最终记录当前上传文件
      secretFileList: [],
      secretMap: {},
      showMeetingOffline: false,
      meetingOffline: {
        meetingDate: null,
        name: '',
        content: '',
        users: []
      },
      fileReady: false,
      meetingReady: false,
      tempFiles: [],
      selectDisabled: false,
      selected: {},
      showSubType: {},
      feishuLink: '',
      subFiles: {},
      SETTLEMENT_INVESRMENT_FILETYPE_ID,
      SETTLEMENT_EXIT_FILETYPE_ID,
      chooseFileId: ''
      // roundValue: {}
    };
  },
  computed: {
    ...mapGetters(['token']),
    headers() {
      return { Authorization: this.token };
    },
    defaultFileList() {
      if (this.file) {
        return [
          {
            uid: '-1',
            name: this.file,
            status: 'done',
            url: ''
          }
        ];
      }
      return [];
    },

    secretReady() {
      return this.secretFileList.every(file => this.secretMap[file.uid]);
    },
    subFileTypeIds: {
      get: function() {
        return Object.keys(this.subFiles).filter(_ => this.subFiles[_] === true);
      },
      set(newVal) {}
    }
  },
  created() {
    if (this.typeId) {
      this.fileTypeId = this.typeId;
      this.current = 1;
    }
    if (this.annexId) {
      this.getPermissionUsers();
    }
    this.getFileList();
  },
  mounted() {
    this.selected = this.roundValue || {};
  },
  methods: {
    async getFileList() {
      let res = await uploadSelectList();
      if (res.code === 200) {
        this.fileList = res.data.map(_ => {
          if (_.subFiletypes) {
            _.subFiletypes = _.subFiletypes.filter(e => {
              return e.status !== -1;
            });
          }
          return _;
        });
      }
      if (this.from === 'meeting') {
        // this.fileList = res.data;
        if (this.categoryType !== '其他') {
          let fileType = this.fileList.find(_ => _.name === this.categoryType);
          this.fileTypeId = fileType.id;
          this.current = 1;
        } else {
          this.current = 0;
          this.fileList = this.fileList.filter(_ => {
            return !meetingUploadlist.some(meetingUploadType => meetingUploadType === _.name);
          });
        }
      }
    },
    getUploadObj(file) {
      file = file || {};
      if (+this.fileTypeId === MEETING_AUDIO_FILETYPE_ID) {
        const meetingOffline = this.meetingOffline;
        meetingOffline.meetingDate = moment(meetingOffline.meetingDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
        meetingOffline.userNames = meetingOffline.users.map(user => user.nickname).join(',');
        return {
          duration: this.uploadDuration,
          companyId: this.$route.query.id || this.companyId,
          fileTypeId: this.fileTypeId,
          password: this.secretMap[file.uid] || '',
          meetingDate: meetingOffline.meetingDate,
          userNames: meetingOffline.users.map(user => user.nickname).join(','),
          content: meetingOffline.content,
          name: meetingOffline.name,
          roundId: this.selected.round,
          phase: this.selected.phase
        };
      } else {
        if (!Array.isArray(this.selected)) {
          this.selected = [this.selected];
        }
        return {
          companyId: this.$route.query.id || this.companyId,
          fileTypeId: this.fileTypeId,
          fileSubtypeIdStr: this.subFileTypeIds.length > 0 ? JSON.stringify(this.subFileTypeIds) : '',
          password: this.secretMap[file.uid] || '',
          phaseAndRoundMapStr: this.from === 'meeting' ? JSON.stringify([{ round: this.round, phase: 1 }]) : JSON.stringify(this.selected)
        };
      }
    },
    async getPermissionUsers() {
      let res;
      if (this.annexId) {
        res = await getPermissionUsers({ companyFileId: this.annexId });
      } else {
        res = await getPermissionUsers({ companyFileId: this.companyFileId[0] });
      }
      if (res.code === 200) {
        this.permission = res.data.list;
        if (!this.customPermission.length) {
          this.isDefault = res.data.authType;
          this.customPermission = [...res.data.list];
        }
      }
    },
    async setPermissionUsers(ifCheckNotify = false) {
      let canViewUserIds = [];
      let canDownloadUserIds = [];
      let canOperateUserIds = [];
      let permission = [];
      if (+this.isDefault === 0) {
        permission = this.permission;
      } else {
        permission = this.customPermission;
      }
      permission.forEach(item => {
        if (+item.companyFileTypeId === 0) {
          item.users.forEach(user => {
            canViewUserIds.push(user.id);
          });
        } else if (+item.companyFileTypeId === 1) {
          item.users.forEach(user => {
            canDownloadUserIds.push(user.id);
          });
        } else {
          item.users.forEach(user => {
            canOperateUserIds.push(user.id);
          });
        }
      });
      if (!canOperateUserIds.length) {
        this.$message.error('可设置权限不能为空');
        return;
      }
      const res = await setPermissionUsers({
        ifCheckNotify: false,
        companyFileId: this.companyFileId.join(','),
        isDefault: +this.isDefault === 0 ? true : false,
        canViewUserIds: canViewUserIds.join(','),
        canDownloadUserIds: canDownloadUserIds.join(','),
        canOperateUserIds: canOperateUserIds.join(',')
      });
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.$emit('uploadedFile', this.uploadFiles);
        this.$emit('close');
        this.$emit('update', this.companyFileId);
      }
    },
    checkTempEdit(index) {
      return +this.tempEdit === +index;
    },
    permissChange(value) {
      this.isDefault = value.toString();
      if (+this.isDefault === 0) {
        this.getPermissionUsers();
      }
    },
    choseUserIds(users, index) {
      this.$set(this.customPermission, index, {
        companyFileTypeDesc: this.customPermission[index].companyFileTypeDesc,
        companyFileTypeId: this.customPermission[index].companyFileTypeId,
        users: users
      });
    },
    delUserIds(user, index) {
      const item = this.customPermission[index];
      item.users = item.users.filter(_user => _user.id !== user.id);
    },
    delAllUsers(index) {
      const item = this.customPermission[index];
      item.users = [];
    },
    chooseOfflineMeetingUsers(users) {
      this.meetingOffline.users = users;
    },
    delOfflineMeetingUsers(user) {
      this.meetingOffline.users = this.meetingOffline.users.filter(_user => _user.id !== user.id);
    },
    chooseFile(obj) {
      let fileTypeId = this.fileTypeId;
      if (fileTypeId !== obj.id) {
        this.subFileTypeIds = [];
        this.subFiles = {};
        if (this.showSubType.hasOwnProperty(fileTypeId)) {
          this.showSubType[fileTypeId] = false;
        }
        this.chooseFileId = '';
      }
      this.fileTypeId = obj.id;
      if (obj.subFiletypes && obj.subFiletypes.length > 0) {
        Object.keys(this.showSubType).forEach(_ => {
          if (_ === this.fileTypeId) {
            this.showSubType[_] = true;
          } else {
            this.showSubType[_] = false;
          }
        });
        this.showSubType[this.fileTypeId] = true;
      }
    },
    async beforeUpload(file) {
      if (file.size / 1024 / 1024 > 500) {
        this.$message.warning('请选择小于500M的文件');
        return false;
      }
      const parts = file.name.split('.');
      const fileType = parts[parts.length - 1];
      if (+this.fileTypeId === MEETING_AUDIO_FILETYPE_ID) {
        return new Promise((resolve, reject) => {
          const fileNameArr = file.name.split('.');
          if (fileNameArr[fileNameArr.length - 1] !== 'm4a') {
            this.$message.error('请上传m4a格式文件');
            reject();
          } else {
            const url = URL.createObjectURL(file);
            const audioElement = new Audio(url);
            let duration;
            this.loadedmetadataFunction = () => {
              duration = audioElement.duration;
              if (duration >= 3 * 60 * 60) {
                this.$message.error('音频时间不能超过180min');
                reject();
              } else {
                this.uploadDuration = parseInt(duration, 10);
                resolve(duration);
              }
              audioElement.removeEventListener('loadedmetadata', this.loadedmetadataFunction);
            };
            audioElement.addEventListener('loadedmetadata', this.loadedmetadataFunction);
          }
        });
      }
      if (['xlsx', 'xls', 'csv', 'pdf'].includes(fileType)) {
        const reader = new FileReader();
        reader.onload = e => {
          const data = e.target.result;
          if (fileType === 'xlsx' || fileType === 'xls' || fileType === 'csv') {
            try {
              xlsx.read(data, {
                type: 'binary',
                bookSheets: true
              });
              Event.$emit(`upConfirm${file.uid}`);
            } catch (error) {
              file.isSecret = true;
              this.getPassword(file);
            }
          } else if (fileType === 'pdf') {
            import('pdfjs-dist-sourcecodecap/webpack').then(pdfjs => {
              pdfjs
                .getDocument(data)
                .then(msg => {
                  Event.$emit(`upConfirm${file.uid}`);
                })
                .catch(error => {
                  file.isSecret = true;
                  this.getPassword(file);
                });
            });
          }
        };
        if (fileType === 'xlsx' || fileType === 'csv' || fileType === 'xls') {
          reader.readAsBinaryString(file);
        } else if (fileType === 'pdf') {
          reader.readAsArrayBuffer(file);
        }
        return new Promise((resolve, reject) => {
          Event.$once(`upConfirm${file.uid}`, (startUpload = true) => {
            if (startUpload) {
              if (this.from === 'meeting') {
                // this.fileReady = true
                this.tempFiles.push(file);
              } else {
                this.uploadFiles.push(file);
                resolve(true);
              }
            } else {
              reject();
            }
          });
          Event.$once(`meetingConfirm`, () => {
            this.remainUpload = this.tempFiles.length;
            this.uploadFiles.push(file);
            resolve(true);
          });
          if (this.from === 'meeting') {
            Event.$on(`delete${this.categoryType}`, file => {
              // this.remainUpload = this.tempFiles.length;
              this.tempFiles = this.tempFiles.filter(_ => _.name !== file.name);
              // this.uploadFiles.push(file);
              reject(false);
            });
          }
        });
      } else {
        if (this.from !== 'meeting') {
          this.uploadFiles.push(file);
          return true;
        } else {
          this.tempFiles.push(file);
          return new Promise((resolve, reject) => {
            Event.$once(`meetingConfirm`, () => {
              this.remainUpload = this.tempFiles.length;
              this.uploadFiles.push(file);
              resolve(true);
            });
            Event.$once(`delete${this.categoryType}`, file => {
              this.tempFiles = this.tempFiles.filter(_ => _.name !== file.name);
              reject(false);
            });
          });
        }
      }
    },

    getPassword(file) {
      this.secretFileList.push(file);
      Event.$once('passOk', passOk => {
        Event.$emit(`upConfirm${file.uid}`, passOk);
      });
    },

    async removeFile(file) {
      const index = this.uploadFiles.findIndex(item => item.name === file.name);
      this.uploadFiles.splice(index, 1);
      this.companyFileId.splice(index, 1);
      let res = await deleteFile(file.response.data);
    },
    handleChange(info) {
      const status = info.file.status;
      console.log('upload change');
      if (status === 'done') {
        let res = info.file.response;
        if (res.code === 200) {
          this.uploadFiles = info.fileList;
          this.$message.success('上传成功');
          this.selectDisabled = true;
        } else {
          this.$message.error(res.msg || `文档${info.file.name}上传失败，请联系加加处理`, 5);
          let index = info.fileList.findIndex(item => item.uid === info.file.uid);
          info.fileList.splice(index, 1);
          this.uploadFiles = this.uploadFiles.filter(file => file.uid !== info.file.uid);
        }
        this.remainUpload--;
      } else if (status === 'error') {
        this.$message.error('上传失败');
        this.remainUpload--;
      }
      if (this.remainUpload === 0) {
        this.emitUploaded();
      }
    },
    deleteFeishu(index) {
      this.feishuList.splice(index, 1);
    },
    checkMeetingOfflineWords() {
      if (!this.meetingOffline.meetingDate) {
        this.$message.error('请选择会议日期');
        return false;
      }
      if (!this.meetingOffline.name) {
        this.$message.error('请填写会议名称');
        return false;
      }
      return true;
    },
    async next(finish = false) {
      if (+this.current === 0 && !this.fileTypeId) {
        return this.$message.error('请选择文件目录');
      }
      if (
        (this.fileTypeId === SETTLEMENT_INVESRMENT_FILETYPE_ID || this.fileTypeId === SETTLEMENT_EXIT_FILETYPE_ID) &&
        this.showSubType[this.fileTypeId] &&
        this.subFileTypeIds.length <= 0
      ) {
        return this.$message.error('请选择文件目录');
      }
      if (
        this.fileTypeId !== SETTLEMENT_INVESRMENT_FILETYPE_ID &&
        this.fileTypeId !== SETTLEMENT_EXIT_FILETYPE_ID &&
        this.showSubType[this.fileTypeId] &&
        !this.chooseFileId
      ) {
        return this.$message.error('请选择文件目录');
      }
      if (+this.current === 0 && +this.fileTypeId === MEETING_AUDIO_FILETYPE_ID && !this.showMeetingOffline) {
        this.showMeetingOffline = true;
        return;
      }
      if (this.showMeetingOffline) {
        if (this.checkMeetingOfflineWords()) {
          this.showMeetingOffline = false;
        } else {
          return;
        }
      }
      if (+this.current === 1) {
        this.uploadFiles.forEach(item => {
          let companyFileId;
          if (+this.fileTypeId === MEETING_AUDIO_FILETYPE_ID) {
            companyFileId = item.response.data.companyFileId;
          } else {
            companyFileId = item.response.data;
          }
          this.companyFileId.push(companyFileId);
        });
        if (this.companyFileId.length === 0 && this.feishuList.length === 0) {
          return this.$message.error('请上传文件');
        }
        if (this.feishuList.length >= 0) {
          await Promise.all(
            this.feishuList.map(async i => {
              let res = await this.uploadFile(i.url);
              this.companyFileId.push(res.data);
            })
          );
        }
        await this.getPermissionUsers();
        if (finish) {
          this.setPermissionUsers(true);
          return;
        }
      }
      this.current++;
    },
    last() {
      if (!this.showMeetingOffline) {
        this.current--;
      } else {
        this.showMeetingOffline = false;
        this.meetingOffline.meetingDate = '';
        this.meetingOffline.name = '';
        this.meetingOffline.content = '';
        this.meetingOffline.users = [];
      }
    },
    prev() {
      this.$emit('close');
    },
    confirmPassword() {
      if (!this.secretReady) {
        this.$message.warn('请填写文档密码');
        return;
      }
      Event.$emit('passOk', true);
      this.secretFileList = [];
    },
    cancelPassword() {
      Event.$emit('passOk', false);
      this.secretFileList = [];
    },
    selectOk() {
      this.$emit('close', {
        category: this.categoryType,
        list: this.tempFiles
      });
      this.feishuLink = '';
    },
    getSelected(val) {
      this.selected = val;
    },
    chooseSubFiles(obj) {
      if (obj.typeId !== SETTLEMENT_INVESRMENT_FILETYPE_ID && obj.typeId !== SETTLEMENT_EXIT_FILETYPE_ID) {
        this.chooseFileId = obj.id;
        Object.keys(this.subFiles).forEach(_ => {
          delete this.subFiles[_];
        });
        this.$set(this.subFiles, obj.id, true);
      } else {
        if (this.subFiles.hasOwnProperty(obj.id)) {
          this.$set(this.subFiles, obj.id, !this.subFiles[obj.id]);
        } else {
          this.$set(this.subFiles, obj.id, true);
        }
      }
    },
    async addFeishuLink() {
      let url = this.feishuLink;
      if (this.tempFiles.find(file => file.uid === url)) {
        this.$message.error('已添加此链接，请输入新链接');
        return;
      }
      let linkInfo = await this.getFeishuLinkInfo(url);
      if (!linkInfo.success) {
        return;
      }
      this.feishuLink = '';
      let info = { ...linkInfo.info, uid: url, isFeishu: true };
      if (!info.name) {
        info.name = '未命名文档';
      }
      if (this.from === 'meeting') {
        this.tempFiles.push(info);
        Event.$once(`meetingConfirm`, () => {
          console.log('ssss');
          this.remainUpload = this.tempFiles.length;
          this.uploadFile(url).then(res => {
            if (res.code === 200) {
              info.response = res;
              this.remainUpload--;
              if (this.remainUpload === 0) {
                this.emitUploaded();
              }
            } else {
              this.$message.error(res.msg);
            }
          });
        });
        Event.$once(`delete${this.categoryType}`, file => {
          this.tempFiles = this.tempFiles.filter(_ => _.uid !== file.uid);
        });
      } else {
        this.feishuList.push(info);
      }
    },
    emitUploaded() {
      let list = [...this.uploadFiles, ...this.tempFiles.filter(i => i.isFeishu)];
      Event.$emit('uploaded', {
        categoryType: this.categoryType,
        list: list
      });
    },
    async uploadFile(url) {
      let data = this.getUploadObj();
      if (+this.fileTypeId === MEETING_AUDIO_FILETYPE_ID) {
        return await uploadOfflineNeetingFile({
          ...data,
          feishuLink: url
        }).then(res => {
          res.data = res.data.companyFileId;
          return res;
        });
      } else {
        return await uploadFile({
          ...data,
          link: url
        });
      }
    },
    async getFeishuLinkInfo(url) {
      let res = await queryFeishuDocInfo(url);
      if (res.code === 200) {
        return {
          success: true,
          info: res.data
        };
      } else {
        return {
          success: false,
          msg: res.msg || '填写文档链接不正确请检查'
        };
      }
    }
  }
};
</script>
<style lang="less" scoped>
.choose_file,
.steps-content {
  width: 300px;
  margin: auto;
  margin-top: 36px;
  position: relative;
}
.steps-content {
  width: 400px !important;
  margin-bottom: 16px;
  .ant-upload-text {
    font-size: 14px !important;
  }
}
.permiss_settings {
  margin: auto;
  margin-top: 16px;
  li {
    min-height: 50px;
    .ant-btn-primary {
      margin-left: 10px;
    }
  }
}
.file_box {
  max-height: 260px;
  .ant-radio-group {
    width: 100%;
  }
}
.label {
  display: inline-block;
  margin-right: 10px;
  padding-top: 20px;
}
.file_item {
  // display: flex;
  align-items: center;
  color: #999;
  cursor: pointer;
  // height: 33px;
  padding: 5px 0px 5px 16px;
  background: #fff;
  // padding-left: 16px;
  &:nth-child(odd) {
    background: #f4f4f4;
  }
  .anticon-file {
    margin-right: 10px;
    color: #000;
  }
}
.sub-file {
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  color: #999;
  cursor: pointer;
  // height: 33px;
  padding: 5px 0px 0px 30px;
  .checkbox {
    margin-right: 5px;
  }
}
.btn {
  margin-left: 10px;
}
.tips {
  color: #999;
  font-size: 12px;
  margin-left: 20px;
}
.secret-content {
  .password-line {
    margin: 5px 0;
    display: flex;
    align-items: center;
  }
  .title {
    font-size: 12px;
    padding-right: 5px;
    color: #1890ff;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .lock-icon {
    color: #1890ff;
    font-size: 12px;
  }
}
.warn {
  font-size: 12px;
  color: #f5222d;
  padding: 5px 0;
}
.warn-box {
  padding: 10px 40px;
}
.btns {
  display: flex;
  padding-top: 10px;
  justify-content: flex-end;
  .btn {
    margin: 0 5px;
  }
}

.lock-icons {
  position: absolute;
  width: 20px;
  height: 100px;
  left: -20px;
  top: 157px;
  font-size: 12px;
  .icon {
    height: 22px;
    line-height: 22px;
    &:not(:first-child) {
      margin-top: 8px;
    }
  }
}
.feishu-list-item {
  display: flex;
  justify-content: space-between;
}
.meeting_offline {
  width: 400px;
  margin: auto;
  margin: 36px 0;
  position: relative;
  .content-item {
    margin-top: 20px;
    .item-title {
      width: 100px;
    }
    display: flex;
    align-items: center;
  }
}
</style>
